import React, { useEffect } from 'react'

export default function LightboxModal({ images = [], currentIndex = 0, isOpen = false, onClose, onNavigate }) {
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowRight') onNavigate((currentIndex + 1) % images.length)
      if (e.key === 'ArrowLeft') onNavigate((currentIndex - 1 + images.length) % images.length)
    }

    window.addEventListener('keydown', handleKeyDown)
    document.body.style.overflow = 'hidden'

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, currentIndex, images, onClose, onNavigate])

  if (!isOpen || images.length === 0) return null

  const currentImg = images[currentIndex]

  return (
    <div 
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 sm:p-8 animate-fadeIn"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Billedfremviser"
    >
      {/* Top Bar with Close */}
      <div className="absolute top-4 right-4 z-50 flex items-center gap-3">
        <span className="text-white/80 text-xs font-mono bg-white/10 px-3 py-1 rounded-full">
          {currentIndex + 1} / {images.length}
        </span>
        <button
          type="button"
          onClick={onClose}
          className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-lg transition-colors focus:outline-none"
          aria-label="Luk billedvisning"
        >
          <i className="fa-regular fa-xmark" aria-hidden="true"></i>
        </button>
      </div>

      {/* Prev Button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onNavigate((currentIndex - 1 + images.length) % images.length)
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/40 hover:bg-black/70 text-white flex items-center justify-center text-xl transition-all border border-white/20 focus:outline-none z-50"
          aria-label="Forrige billede"
        >
          <i className="fa-regular fa-chevron-left" aria-hidden="true"></i>
        </button>
      )}

      {/* Next Button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onNavigate((currentIndex + 1) % images.length)
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/40 hover:bg-black/70 text-white flex items-center justify-center text-xl transition-all border border-white/20 focus:outline-none z-50"
          aria-label="Næste billede"
        >
          <i className="fa-regular fa-chevron-right" aria-hidden="true"></i>
        </button>
      )}

      {/* Image Display */}
      <div 
        className="relative max-w-5xl max-h-[85vh] flex items-center justify-center select-none"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={currentImg}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
        />
      </div>
    </div>
  )
}
